import { on as onEvent } from "common/utils/ui/event";
import "./brand-all-products.scss";

const IFRAME_HIDDEN_CLASS = "brand-all-products__iframe--hidden";

const frameStyles = `
  .promo-banner,
  .header-promo-carousel,
   header,
  .products__sitejabber-section,
  .product-details-badges-carousel,
  .masthead,
  .footer {
    display: none;
  }

  .main-content {
    padding-top: 16px;

    @media (min-width: 992px) {
      padding-top: 36px;
    }
  }
`;

const $getLoading = () => document.getElementById("all-products-loading");
const $getIframe = () => document.getElementById("all-products-iframe");
const $getProductCards = document => document.querySelectorAll(".js-product-card");
const $getBrandAsideFilter = document =>
  document.querySelector("[data-ga-event-action='brand']")?.parentElement;
const $getBrandLogoAsideFilter = document =>
  document.querySelector("[data-ga-event-action='brandLogo']")?.parentElement;

const handleLoad = () => {
  const $iframe = $getIframe();
  const $loading = $getLoading();

  const onLoad = () => {
    const { contentDocument } = $iframe;

    // apply specifiec styles
    const $style = document.createElement("style");
    $style.textContent = frameStyles;
    contentDocument.head.appendChild($style);

    // hide elements
    $getBrandAsideFilter(contentDocument)?.classList?.add("hidden");
    $getBrandLogoAsideFilter(contentDocument)?.classList?.add("hidden");

    // show iframe
    $iframe.classList.remove(IFRAME_HIDDEN_CLASS);
    $loading.classList.add("hidden");

    // open pdp links in parent window
    $getProductCards(contentDocument).forEach($el => {
      const $link = $el;
      $link.target = "_parent";
    });

    // toggle loading while iframe location is changing
    const onClick = () => {
      $iframe.classList.add(IFRAME_HIDDEN_CLASS);
      $loading.classList.remove("hidden");
    };
    onEvent("click", "a:not([target='_parent'])", onClick, false, contentDocument);
  };

  $iframe.addEventListener("load", onLoad);
};

const handlePostMessages = () => {
  const $iframe = $getIframe();

  window.addEventListener("message", ({ data, source }) => {
    // adjust iframe height
    if ($iframe.contentWindow === source && data.height) {
      $iframe.height = `${data.height}px`;
      $iframe.style.height = `${data.height}px`;
    }
  });
};

const initFrame = () => {
  handleLoad();
  handlePostMessages();
};

export default () => {
  const $iframe = $getIframe();
  if (!$iframe) return;

  initFrame();
};
